import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../shared/HubLayout.css';
import SubNav from '../layout/SubNav';
import { useMobileSubNav } from '../layout/MobileNavContext';
import { useHubScreen } from '../layout/useHubScreen';
import Teams, { TeamsActions } from './teams/Teams';
import Areas, { AreasActions } from './areas/Areas';
import Breeds, { BreedsActions } from './breeds/Breeds';
import DeathCauses, { DeathCausesActions } from './death-causes/DeathCauses';
import FinanceCurrencySettings from './finance-categories/FinanceCurrencySettings';
import LotFields, { LotFieldsActions } from './lot-fields/LotFields.js';
import SectionDescription from '../shared/SectionDescription';

const SUB_PATHS = ['team', 'areas', 'breeds', 'death-causes', 'finance-currency', 'lot-fields'];

const SECTION_INFO = [
  { titleKey: 'team_section_title',          textKey: 'team_section_text' },
  { titleKey: 'areas_section_title',         textKey: 'areas_section_text' },
  { titleKey: 'breeds_section_title',        textKey: 'breeds_section_text' },
  { titleKey: 'death_causes_section_title',  textKey: 'death_causes_section_text' },
  { titleKey: 'currency_section_title',      textKey: 'currency_section_text' },
  { titleKey: 'lot_fields_section_title',    textKey: 'lot_fields_section_text' },
];

export const RanchSettingsHub = () => {
  const { t } = useTranslation();
  const { subTab, screen, setScreen } = useHubScreen();
  const navigate = useNavigate();
  const { setSubNav } = useMobileSubNav();

  const activeSubTab = Math.max(0, SUB_PATHS.indexOf(subTab));

  const subTabs = [t("team"), t("areas"), t("breeds"), t("death_causes"), t("currency"), t("lot_fields")];

  const handleSubTabClick = (index) => navigate(`/ranch-settings/${SUB_PATHS[index]}`);

  useEffect(() => {
    setSubNav({ tabs: subTabs, activeTab: activeSubTab, onTabClicked: handleSubTabClick });
    return () => setSubNav(null);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSubTab, setSubNav]);

  return (
    <div className="hub">
      <div className="hub-header">
        <SubNav tabs={subTabs} activeTab={activeSubTab} onTabClicked={handleSubTabClick} />
        <div className="hub-actions">
          {activeSubTab === 0 && <TeamsActions screen={screen} setScreen={setScreen} />}
          {activeSubTab === 1 && <AreasActions screen={screen} setScreen={setScreen} />}
          {activeSubTab === 2 && <BreedsActions screen={screen} setScreen={setScreen} />}
          {activeSubTab === 3 && <DeathCausesActions screen={screen} setScreen={setScreen} />}
          {activeSubTab === 5 && <LotFieldsActions screen={screen} setScreen={setScreen} />}
        </div>
      </div>
      <div className="hub-content">
        <SectionDescription
          title={t(SECTION_INFO[activeSubTab].titleKey)}
          text={t(SECTION_INFO[activeSubTab].textKey)}
        />
        {activeSubTab === 0 && <Teams screen={screen} setScreen={setScreen} hideHeader />}
        {activeSubTab === 1 && <Areas screen={screen} setScreen={setScreen} hideHeader />}
        {activeSubTab === 2 && <Breeds screen={screen} setScreen={setScreen} hideHeader />}
        {activeSubTab === 3 && <DeathCauses screen={screen} setScreen={setScreen} hideHeader />}
        {activeSubTab === 4 && <FinanceCurrencySettings />}
        {activeSubTab === 5 && <LotFields screen={screen} setScreen={setScreen} hideHeader />}
      </div>
    </div>
  );
};

export default RanchSettingsHub;
